import { Component, EventEmitter, Output, Input } from '@angular/core';
import {FormControl, FormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { AddressServiceService } from '../../services/address-service.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-adress-form',
  standalone: true,
  imports: [ReactiveFormsModule,MatFormFieldModule, MatInputModule, 
    MatButtonModule, MatIconModule, MatRadioModule, CommonModule],
  templateUrl: './adress-form.component.html',
  styleUrl: './adress-form.component.scss'
})
export class AdressFormComponent {
  @Output() adress = new EventEmitter<any>();
  @Output() isValidAddress = new EventEmitter<any>();
  @Input() isNew:boolean = false;

  address: any = [];
  mainAddress: any = [];
  alias: any = [];
  showSave: boolean = false;
  usr: any = '';

  constructor(
    private addressService: AddressServiceService
  ) {
  }

  ngOnInit() {
    this.usr = localStorage.getItem('usr') || '';
    if ( !this.isNew ) {
      this.getAddress();
    }
  }

  direccionInfo = new FormGroup({
    calle: new FormControl('', [Validators.required]),
    colonia: new FormControl('', [Validators.required]),
    exterior: new FormControl('', [Validators.required]),
    interior: new FormControl(''),
    cp: new FormControl('', [Validators.required, Validators.pattern(/\d+/g), Validators.minLength(5), Validators.maxLength(8)]),
    ciudad: new FormControl('', [Validators.required]),
    localidad: new FormControl('', [Validators.required]),
    alias: new FormControl('', [Validators.required]),
    contact: new FormControl(''),
    predeterminada: new FormControl(false),
    isSelected: new FormControl(false)
  });

  setAddress(item: any) {
    this.direccionInfo.controls['calle'].setValue(item?.address ?? '');
    this.direccionInfo.controls['colonia'].setValue(item?.suburb ?? '');
    this.direccionInfo.controls['exterior'].setValue(item?.external ?? '');
    this.direccionInfo.controls['interior'].setValue(item?.internal ?? '');
    this.direccionInfo.controls['cp'].setValue(item?.zip ?? '');
    this.direccionInfo.controls['ciudad'].setValue(item?.city ?? '');
    this.direccionInfo.controls['localidad'].setValue(item?.location ?? '');
    this.direccionInfo.controls['alias'].setValue(item?.alias ?? '');
    this.direccionInfo.controls['contact'].setValue(item?.contact ?? '');
    this.direccionInfo.controls['predeterminada'].setValue(item?.isDefault ?? '');

    this.showSave = item.length == 0;
    this.adress.emit(item);
  }

  getAddress() {
    this.addressService.getAddress(this.usr).subscribe((res: any) => {
      this.address = res.listAddress;
      this.address.forEach((item: any) => {
        this.alias.push(item.alias);
        if ( item.isDefault ) {
          this.mainAddress = item;
        }
      });
      this.setAddress(this.mainAddress);
    })
  }

  sendData() {
    if ( this.isNew) {
      let payload: any = {
        address: this.direccionInfo.controls['calle'].value ?? '',
        suburb: this.direccionInfo.controls['colonia'].value ?? '',
        external: this.direccionInfo.controls['exterior'].value ?? '',
        internal: this.direccionInfo.controls['interior'].value ?? '',
        zip: this.direccionInfo.controls['cp'].value ?? '',
        city: this.direccionInfo.controls['ciudad'].value ?? '',
        location: this.direccionInfo.controls['localidad'].value ?? '',
        contacto: this.direccionInfo.controls['contact'].value ?? '',
        alias: 'Principal',
        isDefault: true,
      };
      this.direccionInfo.controls['alias'].setValue('Principal');
      console.log('this.direccionInfo :', this.direccionInfo);
      this.adress.emit(this.direccionInfo?.valid ? payload : null );
      this.isValidAddress.emit(this.direccionInfo?.valid);
    }
  }

  saveInfo() {
    if ( this.direccionInfo?.valid ) {
      let payload: any = {
        address: this.direccionInfo.controls['calle'].value,
        suburb: this.direccionInfo.controls['colonia'].value,
        external: this.direccionInfo.controls['exterior'].value,
        internal: this.direccionInfo.controls['interior'].value,
        zip: this.direccionInfo.controls['cp'].value,
        city: this.direccionInfo.controls['ciudad'].value,
        location: this.direccionInfo.controls['localidad'].value,
        contacto: this.direccionInfo.controls['contact'].value,
        alias: this.direccionInfo.controls['alias'].value,
        isDefault: true,
        user_id: this.usr 
      }

      this.addressService.addAddress(payload).subscribe((res: any) => {
        payload['id'] = res.address.id;
        this.setAddress(payload);
        this.showSave = false;
      });
    }
  }
}
